import { render, staticRenderFns } from "./associatedBomTable.vue?vue&type=template&id=372a0071&"
import script from "./associatedBomTable.vue?vue&type=script&lang=js&"
export * from "./associatedBomTable.vue?vue&type=script&lang=js&"
import style0 from "./associatedBomTable.vue?vue&type=style&index=0&id=372a0071&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports